import { useQuery } from 'react-query';

import { getAllTherapyCompanyAssessments } from 'App/services/AdminService';
import { errorHandler } from 'App/utils';

function useFetchTherapyCompanyAssessments(therapyId, companyId) {
    return useQuery(
        ['therapy', therapyId, 'company', companyId],
        () => (therapyId && companyId ? getAllTherapyCompanyAssessments(therapyId, companyId) : null),
        {
            onError: errorHandler,
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchTherapyCompanyAssessments;
